export const loanProgramSectionStyles = {
  padding: 0,
};

export const loanProgramTitleStyles = {
  marginBottom: '16px',
};

export const ppeIndicatorStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '8px',
  padding: '1px 6px',
  borderRadius: ({ shape }) => shape.radius.xs,
  backgroundColor: ({ palette }) => palette.info.light,
  color: ({ palette }) => palette.info.dark,
  fontSize: '11px',
  fontWeight: 600,
  lineHeight: '16px',
};
